import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=403aeae0&"
import script from "./SideDrawer.vue?vue&type=script&lang=ts&"
export * from "./SideDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports